import i18n from '../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {getPhoneRuleObj, LOT_NO_REGEX} from "@/plugins/vee-validate";
import DateModel from "../../sales/Date.model";
import {store} from "@/plugins/vuex";

export default class LotModel extends BaseModel {
  inventory_uuid = null;
  auction_uuid = null;
  buyer_uuid = null;
  lot_no = null;
  status = null;
  low = null;
  high = null;
  reserve = null;
  insurance = null;
  start_price = null;
  hammer_price = null;
  commission = null;
  premium = null;
  dynamic_fields = {};
  sale_tax_rate = null;
  import_tax_rate = null;
  unsold_fee = null;
  handling_fee = null;
  withdrawal_fee = null;
  insurance_fee = null;
  item_location_uuid = null;
  department_uuid = null;
  department = null;
  specialists_uuids = [];
  specialists = [];
  category_uuid = null;
  category = null;
  quantity = null;
  available_quantity = null;
  dates = [new DateModel()];
  winner_bid = null;
  highest_bid = null;
  use_images_for_auction_gallery = false;
  collection_info_enabled = false;
  collection_info_address_1 = null;
  collection_info_address_2 = null;
  collection_info_state = null;
  collection_info_city = null;
  collection_info_zip_code = null;
  collection_info_phone = null;
  collection_info_first_name = null;
  collection_info_last_name = null;
  collection_info_email = null;
  collection_info_notes = null;
  auction_date_uuid = null;
  auction_collection_uuid = null;

  rules = {
    inventory_uuid: 'required',
    lot: 'required',
    auction_uuid: 'required',
    item_location_uuid: 'required',
    department_uuid: 'required',
    category_uuid: 'required',
    quantity: 'required',
    insurance: 'max_value:100|min_value:0',
    commission: 'max_value:100|min_value:0',
    import_tax_rate: 'max_value:100|min_value:0',
    sale_tax_rate: 'max_value:100|min_value:0',

    collection_info_email: 'email|max:73',
    collection_info_phone: getPhoneRuleObj(),
    collection_info_notes: `max:150`,
    lot_no: {
      regex: LOT_NO_REGEX
    },
  };

  attributeLabels = {
    inventory_uuid: i18n.t('Inventory'),
    auction_uuid: i18n.t('Sale'),
    buyer_uuid: i18n.t('Buyer'),
    lot_no: i18n.t('Lot Number'),
    status: i18n.t('Status'),
    low: i18n.t('Low'),
    high: i18n.t('High'),
    reserve: i18n.t('Reserve'),
    insurance: i18n.t('Insurance'),
    start_price: i18n.t('Start Price'),
    hammer_price: i18n.t('Hammer Price'),
    commission: i18n.t('Commission'),
    premium: i18n.t('Premium'),
    sale_tax_rate: i18n.t('Sale Tax Rate'),
    import_tax_rate: i18n.t('Import Tax Rate'),
    unsold_fee: i18n.t('Unsold Fee'),
    handling_fee: i18n.t('Handling Fee'),
    withdrawal_fee: i18n.t('Withdrawal Fee'),
    insurance_fee: i18n.t('Insurance Fee'),
    item_location_uuid: i18n.t('Item Location'),
    department_uuid: i18n.t('Department'),
    category_uuid: i18n.t('Category'),
    specialists_uuids: i18n.t('Specialists'),
    quantity: i18n.t('Quantity'),
    dates: i18n.t('Dates'),
    auction_date_uuid: i18n.t('Session'),
    use_images_for_auction_gallery: i18n.t('Auction Gallery Image'),
    collection_info_enabled: i18n.t('Collection Information'),
    collection_info_address_1: i18n.t('Address 1'),
    collection_info_address_2: i18n.t('Address 2'),
    collection_info_city: i18n.t('City'),
    collection_info_state: i18n.t('State/County'),
    collection_info_zip_code: i18n.t('Zip/Postcode'),
    collection_info_phone: i18n.t('Phone'),
    collection_info_first_name: i18n.t('Contact First Name'),
    collection_info_last_name: i18n.t('Contact Last Name'),
    collection_info_email: i18n.t('Email'),
    collection_info_notes: i18n.t('Collection Notes'),
    auction_collection_uuid: i18n.t('Collection'),
  };

  attributeHints = {};

  constructor(data = {}) {
    super();

    let tmpData = data;
    if (tmpData.uuid) {
      tmpData.inventory_uuid = tmpData.uuid;
      tmpData.quantity = tmpData.available_quantity;
      tmpData.uuid = null;
    }

    Object.assign(this, {...tmpData});
    this.initDynamicFields(this, this.category ? this.category.dynamic_fields_template : null);
  }

  initDynamicFields(object, dynamicFieldsTemplate = null) {
    if (this.is_grouped_item && store.state && store.state.global && store.state.global.defaultItemDynamicFieldsTemplate) {
      return super.initDynamicFields(object, store.state.global.defaultItemDynamicFieldsTemplate);
    }

    return super.initDynamicFields(object, dynamicFieldsTemplate);
  }
}
